import { User } from "../types";
import decode from "jwt-decode";
import { ID_TOKEN, ACCESS_TOKEN, IDPLOGINPROVIDER } from "@constants";
import { GoogleLoginResponse } from "react-google-login";

export function getUserFromSessionStorage(): User | null {
  const id_token = sessionStorage.getItem(ID_TOKEN);
  const access_token = sessionStorage.getItem(ACCESS_TOKEN);
  const provider = (sessionStorage.getItem(IDPLOGINPROVIDER) || undefined) as
    | "google"
    | "entra"
    | undefined;

  if (id_token && access_token) {
    try {
      const date = new Date();
      const {
        sub: id,
        name,
        email,
        upn,
        preferred_username,
        picture: avatar,
        exp,
      } = decode(id_token);

      // Entra tokens carry the real identifier as upn/preferred_username, not email (matches onEntraSignIn)
      const resolvedEmail =
        provider === "entra" ? upn || preferred_username : email;

      return exp * 1000 - date.getTime() > 0
        ? {
            id,
            name,
            email: resolvedEmail,
            upn: provider === "entra" ? resolvedEmail : undefined,
            avatar,
            id_token,
            access_token,
            provider,
          }
        : null;
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.log("There was a problem decoding user token", error);
      }
    }
  }

  return null;
}

export function getUserFromGoogleLoginResponse(
  response: GoogleLoginResponse
): User {
  const { profileObj: profile, tokenObj: token } = response;
  const { googleId: id, name, email, imageUrl: avatar } = profile;
  const { id_token, access_token } = token;

  return {
    id,
    name,
    email,
    avatar,
    id_token,
    access_token,
  };
}
